import { createContext } from 'react';

/**
 * Ergebnis des EINEN Versions-Checks je Tab (NeuerStandWaechter in RootView)
 * fuer das Banner im Home-Layout (docs/tasks/auto-reload-neuer-stand.md).
 */
export type NeuerStandContextType = {
  updateAvailable: boolean;
};

const NeuerStandContext = createContext<NeuerStandContextType>({
  updateAvailable: false,
});

export const NeuerStandProvider = NeuerStandContext.Provider;

export default NeuerStandContext;
